(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  if (reduce) return

  const show = (root) => {
    const items = [...root.querySelectorAll('[data-reveal-item]')].filter(
      (el) => el.closest('[data-reveal]') === root,
    )
    const targets = items.length ? items : [root]
    const stagger = Number(root.dataset.stagger || 80)
    targets.forEach((el, index) => {
      el.style.transitionDelay = `${index * stagger}ms`
      el.classList.add('is-in')
    })
  }

  const roots = document.querySelectorAll('[data-reveal]')
  const pending = new Set(roots)
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        show(entry.target)
        pending.delete(entry.target)
        observer.unobserve(entry.target)
      })
    },
    { threshold: 0.12 },
  )

  roots.forEach((root) => observer.observe(root))

  window.setTimeout(() => {
    pending.forEach((root) => show(root))
  }, 2500)

  document.querySelectorAll('[data-count]').forEach((el, index) => {
    const target = Number(el.dataset.count || '0')
    const suffix = el.dataset.suffix || ''
    el.textContent = `0${suffix}`

    const tick = (startedAt) => {
      const delay = index * 80
      const duration = 1200
      const frame = (now) => {
        const elapsed = now - startedAt - delay
        if (elapsed < 0) {
          requestAnimationFrame(frame)
          return
        }
        const progress = Math.min(elapsed / duration, 1)
        const eased = 1 - (1 - progress) ** 2
        el.textContent = `${Math.round(target * eased)}${suffix}`
        if (progress < 1) requestAnimationFrame(frame)
      }
      requestAnimationFrame(frame)
    }

    const host = el.closest('[data-reveal]') || el
    const countObserver = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return
        tick(performance.now())
        countObserver.disconnect()
      },
      { threshold: 0.35 },
    )
    countObserver.observe(host)
  })
})()
